import React from 'react'

const LoaderComponent = props => {
  const size = props.size || ''
  const style = {
    color: props.color || null
  }
  return (
    <div className={`la-ball-fall ${size}`} style={style}>
      <div />
      <div />
      <div />
    </div>
  )
}

const SpinnerLoader = () => (
  <div>
    <div className="loader loader-spinner" />
  </div>
)

const MagazineLoader = () => (
  <div className='outer'>
    <builderall-loader loading='true'>
      <div className='intra'></div>
    </builderall-loader>
  </div>
)

export { LoaderComponent, SpinnerLoader, MagazineLoader }



// WEBPACK FOOTER //
// ./src/components/commons/LoaderComponent.js